module.exports = import("https://esm.sh/@supabase/supabase-js@2");;